import React, { forwardRef } from "react"
import type { LucideProps } from "lucide-react"

export const SparkleIconActive = forwardRef<SVGSVGElement, LucideProps>(
  (
    {
      size = 24,
      color = "currentColor",
      strokeWidth = 1.5,
      className,
      ...props
    },
    ref,
  ) => {
    return (
      <svg
        ref={ref}
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        stroke={color}
        strokeWidth={strokeWidth}
        strokeLinecap="round"
        strokeLinejoin="round"
        className={className}
        {...props}
      >
        <path
          key="sparkle-path"
          d="M9.267 15.158C9.175 14.815 8.984 14.505 8.719 14.270C8.454 14.035 8.128 13.885 7.787 13.796L1.382 11.982C1.270 11.952 1.171 11.885 1.100 11.790C1.029 11.695 0.947 11.577 0.947 11.447C0.947 11.317 1.029 11.199 1.100 11.104C1.171 11.009 1.270 10.942 1.382 10.912L7.787 9.098C8.127 8.989 8.453 8.839 8.718 8.604C8.983 8.369 9.174 8.059 9.267 7.716L11.081 1.311C11.111 1.199 11.178 1.100 11.273 1.029C11.368 0.958 11.486 0.947 11.616 0.947C11.746 0.947 11.864 0.958 11.959 1.029C12.054 1.100 12.121 1.199 12.151 1.311L13.965 7.716C14.058 8.057 14.249 8.367 14.514 8.602C14.779 8.837 15.105 8.987 15.446 9.080L21.851 10.894C21.963 10.924 22.062 10.991 22.133 11.086C22.204 11.181 22.286 11.299 22.286 11.429C22.286 11.559 22.204 11.677 22.133 11.772C22.062 11.867 21.963 11.934 21.851 11.964L15.446 13.778C15.105 13.871 14.779 14.021 14.514 14.256C14.249 14.491 14.058 14.801 13.965 15.142L12.151 21.547C12.121 21.659 12.054 21.758 11.959 21.829C11.864 21.900 11.746 21.911 11.616 21.911C11.486 21.911 11.368 21.900 11.273 21.829C12.178 21.758 12.111 21.659 12.081 21.547L9.267 15.158Z"
          fill="currentColor"
          stroke="currentColor"
          strokeWidth="1.5"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  },
)

SparkleIconActive.displayName = "SparkleIconActive"
